import { CHANGE_LANG, TOKENS_REFRESH, TOKENS_REMOVE, TOKENS_TOUCH } from '../actions/app';
import { RootAction } from '../actions';
import { Language } from '../types/common';

export interface AppState {
  language: Language;
  accessToken?: string;
  refreshToken?: string;
  tokensTouched?: number;
  version: string;
  metadata: {};
  isPasswordResetModalVisible?: boolean;
  href: string;
}

const initState: AppState = {
  language: 'ru',
  accessToken: '',
  refreshToken: '',
  version: '',
  metadata: {},
  href: typeof window !== 'undefined' ? window.location.href : '',
};

export default function appReducer(state: AppState = initState, action: RootAction): AppState {
  switch (action.type) {
    case CHANGE_LANG:
      return {
        ...state,
        language: action.payload.language,
      };

    case TOKENS_REFRESH:
      return {
        ...state,
        accessToken: action.payload.accessToken,
        refreshToken: action.payload.refreshToken,
        tokensTouched: action.meta.ts,
      };
    case TOKENS_REMOVE:
      return {
        ...state,
        accessToken: '',
        refreshToken: '',
        tokensTouched: action.meta.ts,
      };
    case TOKENS_TOUCH:
      return {
        ...state,
        tokensTouched: action.meta.ts,
      };
    default:
      return state;
  }
}
